import React from "react";

import { SvgIconProps } from "@mui/material";

import Stack from "@rui/Stack";

import NotificationBadge from "./NotificationBadge";

const SideNavButtonIcon = ({
  highlight = false,
  Icon,
  notifications = 0,
}: {
  highlight?: boolean;
  Icon: React.FunctionComponent<SvgIconProps>;
  notifications?: number;
}) => (
  <Stack
    variant="center"
    sx={{ position: "relative", height: "20px", width: "20px", flexShrink: 0 }}
  >
    {notifications > 0 && (
      <NotificationBadge notifications={notifications} absolutePositioning />
    )}
    <Icon sx={{ fontSize: "16px", color: highlight ? "#4361EE" : undefined }} />
  </Stack>
);

export default SideNavButtonIcon;
